<template>
  <div class="portada-xv" ref="rootRef" aria-label="XV Cover">

    <!-- DECORATIVE FLOWERS -->
    <img src="@/assets/flooor.png" class="flor flor-1" alt="" />
    <img src="@/assets/flooor.png" class="flor flor-2" alt="" />
    <img src="@/assets/moñi.png" class="flor flor-3" alt="" />

    <!-- SPINNING DISCO BALL -->
    <img src="@/assets/diisco.png" class="bola bola-izquierda" alt="" />

    <h1 class="nombre-protagonista2">Allison Ivette</h1><br>

    <!-- CROPPED IMAGE + BOW -->
    <div class="imagen-xv-shell">
      <div class="imagen-xv-wrapper">
        <img
          src="@/assets/Gemini_Generated_Image_5es0i45es0i45es0.png"
          class="imagen-xv"
          alt="Main photo"
        />
      </div>

      <div class="mono-portada">
        <img
          :src="require('@/assets/moñii.png')"
          class="mono-portada-img"
          alt="Decorative bow"
        />
      </div>
    </div><br>

    <h1 class="nombre-protagonista2">My XV</h1><br>

    <!-- MAIN TEXT -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With God’s blessing <br />
        and that of my parents
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">José&nbsp;&nbsp;Luna</h1>
      <h1 class="nombre-protagonista">Maricela&nbsp;&nbsp;Barragán</h1>

      <!-- ✅ GODPARENTS -->
      <div class="padrinos"><br><br>
        <p class="padrinos-titulo">Honorary Godparents</p><br>
        <p class="padrinos-nombres">Juan Carlos Barragán <br>María Elena Palomares</p>

        <p class="padrinos-titulo">Dress Godparents</p><br>
        <p class="padrinos-nombres">Juan Carlos Barragán<br> María Elena Palomares</p>
      </div>

      <p class="parrafo-presentacion">
        There are moments that define our lives, remaining engraved in our soul and memory.
        Today I experience one of those special moments, and I want to share it with those
        who hold a place in my heart. <br>
      </p>
    </section>
  </div>
</template>


<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.padrinos',
        '.parrafo-presentacion'
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0)', duration: 1.1 }
          )

          tl.to(flores, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.12
          }, '-=0.5')

          tl.to(texto, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.12
          }, '-=0.3')

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* PADRINOS */
.padrinos{
  margin-top: 18px;
}
.padrinos-titulo{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color:#6a6a6a;
  margin: 10px 0 2px;
}
.padrinos-nombres{
  font-family: "titulos", cursive;
  font-size: 35px;
  color:#043b73;
  margin: 0 0 8px;
}
</style>


<style scoped>
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  background:#f3f7fd;
  overflow:visible;
  display:flex;
  margin-top:-50px;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:0px 16px 56px;
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
  position: relative; /* para posicionar el moño dentro */
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* 🎀 Moño en la parte superior derecha de la foto */
.mono-portada{
  position:absolute;
  top:35px;
  right: -25px;
  z-index: 9995;
  transform: rotate(22deg);

}
.mono-portada-img{
  width: 240px;
  height: auto;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: -22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 52px;
  color: #043b73;
  margin: 0 0 8px 0;
  line-height: 1.1;
}

.nombre-protagonista2{
  font-family: "titulos", cursive;
  font-size: 82px;
  
  color:#043b73;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:80px; left:-60px; z-index:5; }
.flor-2{ top:205px; right:-80px; transform: rotate(-80deg); z-index:1; width:min(60vw, 340px); }
.flor-3{ bottom:-50px; left:-100px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:210px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:207px; bottom:-128px; z-index:9;}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
